import {
    GETMODULEALLOCATIONLISTFORADMIN_SUCCESS,
    GETMODULEALLOCATIONLISTFORADMIN_FAILED,
    RESET_GETMODULEALLOCATIONLISTFORADMIN,
    LOADING_GETMODULEALLOCATIONLISTFORADMIN,
    NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMODULEALLOCATIONLISTFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETMODULEALLOCATIONLISTFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETMODULEALLOCATIONLISTFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETMODULEALLOCATIONLISTFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
